import React from 'react'
// import WhatsappIcon from '../Assets/images/whatsapp.svg'

const Whatsapp = () => {
  const trackWhatsappClick = () => {
    window.fbq?.('track', 'Contact', {
      contact_method: 'whatsapp'
    });
  };

  return (
    <a href='https://wa.me/5491167917230?text=Hola! Vengo desde la web de Vanity. Quería recibir asesoramiento.' target="_blank" rel="noreferrer" className='whatsapp--link' aria-label='WhatsApp Vanity Estética' onClick={trackWhatsappClick}>
    </a>
  )
}

export default Whatsapp